import React from "react";
import { colorLightGrey } from "../../../utility/constants/colorManager";
import { CustomInput } from "../main_comps/custom_input/CustomInput";
import CustomSelect from "../main_comps/custom_select";

const inputStyle = {
  backgroundColor: "white",
  alignSelf: "center",
  height: 50,
  width: "100%",
  boxShadow: "none",
  outline: "none",
  paddingLeft: 10,
  borderRadius: 5,
  boxSizing: "border-box",
  alignItems: "center",
  display: "flex",
};
const textStyle = {
  fontSize: 13,
  marginLeft: 10,
  fontWeight: "500",
};

const checkboxStyle = {
  height: 20,
  width: 20,
};

export const SerivceProviderDropdown = ({
  value1,
  onChange1,
  value2,
  onChange2,
  serviceProviderNameList,
  rateValue,
  styles,
  textStyles,
}) => {
  return (
    <div>
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <p style={{ ...textStyle, margin: "5px 0px", ...textStyles }}>
          Select service Provider
        </p>
        <CustomSelect
          value={value1}
          onChange={(data) => {
            onChange1(data);
          }}
          options={serviceProviderNameList}
          style={{
            backgroundColor: "white",
            width: "343px",
            height: "41px",
            
            border: "1px solid #CBCACA",
            borderRadius: "6px",
            ...styles,
          }}
        />
      </div>

      <div style={{ width: "70%", marginBottom: "20px" }}>
        <p style={{ ...textStyle, margin: "5px 0px", ...textStyles }}>
          Service Provider Rate
        </p>
        <div
          style={{
            ...inputStyle,
            height: "41px",
            width: "343px",
            border: "1px solid #CBCACA",
            borderRadius: "6px",
          }}
        >
          <CustomInput
            value={rateValue}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder=""
            type="input"
            dropdownStyle={{
              
              width: "20%",
              ...inputStyle,
            }}
            inputStyles={{
              backgroundColor: "transparent",
              border: "none",
              boxShadow: "none",
            }}
            disabled={true}
          />
        </div>
      </div>
    </div>
  );
};

function CheckBoxInput({
  title,
  value,
  onChange,
  mainStyle,
  boxStyle,
  textStyling,
  defaultChecked,
  checked,
}) {
  return (
    <div
      style={{
        backgroundColor: colorLightGrey,
        marginBottom: 5,
        ...inputStyle,
        ...mainStyle,
      }}
    >
      <input
        type="checkbox"
        style={{ ...checkboxStyle, ...boxStyle }}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
      />

      <p style={{ ...textStyle, ...textStyling }}>{title}</p>
    </div>
  );
}

export default CheckBoxInput;
